import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConnectedVehicleRec, CheckedDTC, CheckedCAMPAIGN, CheckedRECOMMENDED, ImportedRECOMMENDED, ImportedDTC, ImportedCAMPAIGN } from 'src/models';
import { IStoreState } from 'src/store';
import * as acBase from 'src/store/states/GenericActionCreator';
import { AxiosError } from 'axios';

/** Interfaces */
export interface IConnectedVehicleState {
    ConnectedVehicleRec: ConnectedVehicleRec;
    CheckedDTC: CheckedDTC[];
    ImportedDTC: ImportedDTC[];
    CheckedCampaign: CheckedCAMPAIGN[];
    ImportedCampaign: ImportedCAMPAIGN[];
    CheckedRecommended: CheckedRECOMMENDED[];
    ImportedRecommended: ImportedRECOMMENDED[];
}

/** Initial State */
export const initialState: IConnectedVehicleState = {
    ConnectedVehicleRec: {
        tlmId: '',
        newTlmId: '',
        custName: '',
        VIN: '',
        year: '',
        make: '',
        parentMake: '',
        modelNum: '',
        modelDesc: '',
        series: '',
        buildDate: '',
        marketName: '',
        bodyStyle: '',
        serialNum: '',
        orderNum: '',
        prodPoint: '',
        prodPlant: '',
        extColor: '',
        intColor: '',
        airConditioning: '',
        powerSteering: '',
        turbo: '',
        licenseNum: '',
        newUsed: '',
        chassisNum: '',
        keyNum: '',
        secondKeyNum: '',
        keylessNum: '',
        keychipNum: '',
        alarmNum: '',
        frontSafetyRating: '',
        rearSafetyRating: '',
        driverSafetyRating: '',
        passengerSafetyRating: '',
        rolloverSafetyRating: '',
        overallSafetyRating: '',
        seatingCapacity: '',
        weightRating: '',
        weight: '',
        engineNum: '',
        engineConfig: '',
        engineSize: '',
        engineType: '',
        engineCylinders: '',
        baseMSRP: '',
        optionMSRP: '',
        totalMSRP: '',
        freight: '',
        modelPhaseCode: '',
        fuelCode: '',
        fuelType: '',
        fuelCapacity: '',
        trans: '',
        transCode: '',
        transDesc: '',
        stockId: '',
        custNum: '',
        salesNum: '',
        mmc: '',
        sellingDealerNum: '',
        prodDate: '',
        inSvcDate: '',
        prodHr: '',
        delDate: '',
        delOdom: '',
        demoDate: '',
        demoOdom: '',
        factoryWarrExpDate: '',
        factoryWarrExpMile: '',
        svcDays: '',
        teamCode: '',
        lastActivityDate: '',
        driverWindow: '',
        passengerWindow: '',
        rearLeftWindow: '',
        rearRightWindow: '',
        sunroof: '',
        addTstamp: '',
        mileage: '',
        mileTstamp: '',
        mileStatus: '',
        mileAvgDistance: '',
        numVisits: '',
        battLevel: '',
        battHealth: '',
        battTstamp: '',
        battIcon: '',
        battDesc: '',
        battLastUpdTstamp: '',
        battStatus: '',
        battActualStatus: '',
        battHealthTstamp: '',
        battFillStatus: '',
        battFillTstamp: '',
        battFillLevel: '',
        battElecStatus: '',
        battElecTstamp: '',
        battElecDte: '',
        fuelAmt: '',
        fuelTstamp: '',
        fuelStatus: '',
        fuelMilesPerCapacity: '',
        fuelCity: '',
        fuelHwy: '',
        fuelCombined: '',
        fuelEquivCity: '',
        fuelEquivHwy: '',
        fuelEquivCombined: '',
        fuelDistToEmpty: '',
        tireLFValue: '',
        tireLFStatus: '',
        tireLFTstamp: '',
        tirePressLFValue: '',
        tirePressLFStatus: '',
        tirePressLFTstamp: '',
        tireRFValue: '',
        tireRFStatus: '',
        tireRFTstamp: '',
        tirePressRFValue: '',
        tirePressRFStatus: '',
        tirePressRFTstamp: '',
        tireLRValue: '',
        tireLRStatus: '',
        tireLRTstamp: '',
        tirePressLRValue: '',
        tirePressLRStatus: '',
        tirePressLRTstamp: '',
        tireILRValue: '',
        tireILRStatus: '',
        tireILRTstamp: '',
        tirePressILRValue: '',
        tirePressILRStatus: '',
        tirePressILRTstamp: '',
        tireRRValue: '',
        tireRRStatus: '',
        tireRRTstamp: '',
        tirePressRRValue: '',
        tirePressRRStatus: '',
        tirePressRRTstamp: '',
        tireIRRValue: '',
        tireIRRStatus: '',
        tireIRRTstamp: '',
        tirePressIRRValue: '',
        tirePressIRRStatus: '',
        tirePressIRRTstamp: '',
        tireSpareValue: '',
        tirePressSpareValue: '',
        tirePressSpareStatus: '',
        tirePressSpareTstamp: '',
        tireFrontRecomValue: '',
        tireFrontRecomStatus: '',
        tireFrontRecomTstamp: '',
        tireRearRecomValue: '',
        tireRearRecomStatus: '',
        tireRearRecomTstamp: '',
        tireDualRearValue: '',
        tireDualRearStatus: '',
        tireDualRearTstamp: '',
        tireSpeedValue: '',
        tirePressureValue: '',
        tirePressureTstamp: '',
        tirePressureLocValue: '',
        tirePressureLocStatus: '',
        tirePressureLocTstamp: '',
        tirePressureSysValue: '',
        tirePressureSysStatus: '',
        tirePressureSysTstamp: '',
        engineLight: '',
        oilLifeValue: '',
        oilStatus: '',
        oilTstamp: '',
        oilIcon: '',
        oilCheckStatus: '',
        oilQtyStatus: '',
        oilDesc: '',
        oilRemainDistance: '',
        oilReplaceIcon: '',
        oilReplaceStatus: '',
        oilReplaceDesc: '',
        oilReplaceTstamp: '',
        oilZeroYears: '',
        oilZeroMonths: '',
        oilZeroDays: '',
        statusCode: '',
        lockValue: '',
        lockStatus: '',
        lockTstamp: '',
        alarmValue: '',
        alarmStatus: '',
        alarmTstamp: '',
        remStartStatusValue: '',
        remStartStatusStatus: '',
        remStartStatusTstamp: '',
        remStartDuration: '',
        remStartTimeRemain: '',
        remStartStatus: '',
        remStartTstamp: '',
        exhaustValue: '',
        airFilterValue: '',
        locLatitude: '',
        locLongitude: '',
        locTstamp: '',
        gpsStatus: '',
        gpsState: '',
        firstRoDate: '',
        lastRoNum: '',
        lastRoDate: '',
        lastRoMile: '',
        vehicleVisitId: '',
        checkInTstamp: '',
        dealerCode: '',
        dealerName: '',
        rptVisitCount: '',
        rptVisitStatus: '',
        rptVisitUrl: '',
        deepSleepValue: '',
        deepSleepTstamp: '',
        firmwareValue: '',
        firmwareTstamp: '',
        plugValue: '',
        plugStatus: '',
        plugTstamp: '',
        hybridValue: '',
        hybridStatus: '',
        hybridTstamp: '',
        chargeValue: '',
        chargeStatus: '',
        chargeTstamp: '',
        chargeStartValue: '',
        chargeStartStatus: '',
        chargeStartTstamp: '',
        chargeEndValue: '',
        chargeEndStatus: '',
        chargeEndTstamp: '',
        privacyCompanyName: '',
        privacyConsentName: '',
        privacyStatusCode: '',
        privacyTstamp: '',
        privacyStartTstamp: '',
        privacyDeviceType: '',
        privacyDeviceValue: '',
        deviceUrl: '',
        deviceName: '',
        remTeleCalls: '',
        tele: '',
        teleContract: '',
        telemetryTstamp: '',
        sscFlag: '',
        damagedFlag: '',
        vehUpdatedTstamp: '',
        vehCheckCode: '',
        dlrCategory: '',
        vehCategory: '',
        auth: '',
        settingsLocData: '',
        settingsTstamp: '',
        settingsConnect: '',
        settingsData: '',
        safety: '',
        svcConnect: '',
        remoteActive: '',
        digitalKeyRemote: '',
        destinationAssist: '',
        navigation: '',
        virtualAssistant: '',
        integratedStreaming: '',
        wifi: '',
        dtcActive: '',
        dtc: [],
        option: [],
        log: [],
        mfgInq: [],
        campaign: [],
        recommended: [],
        ac: [],
        mc: [],
        xc: [],
        svcHist: [],
        comm: [],
        printError: '',
        importError: '',
        invokeError: '',
        readError: '',
    },
    CheckedDTC: [],
    ImportedDTC: [],
    CheckedCampaign: [],
    ImportedCampaign: [],
    CheckedRecommended: [],
    ImportedRecommended: [],
};

export const ConnectedVehicleSlice = createSlice({
    name: 'ConnectedVehicle',
    initialState: initialState as IConnectedVehicleState,
    reducers: {
        receiveConnectedVehicle: (state, action: PayloadAction<ConnectedVehicleRec>) => {
            state.ConnectedVehicleRec = action.payload;
        },
        clearConnectedVehicle: (state) => {
            state.ConnectedVehicleRec = initialState.ConnectedVehicleRec;
        },
        printConnectedVehicle: (state, action: PayloadAction<ConnectedVehicleRec>) => {
            state.ConnectedVehicleRec.printError = action.payload.printError;
        },
        toggleDtc: (state, action: PayloadAction<CheckedDTC[]>) => {
            state.CheckedDTC = action.payload;
        },
        toggleImportedDtc: (state, action: PayloadAction<ImportedDTC[]>) => {
            state.ImportedDTC = action.payload;
            state.CheckedDTC = [];
        },
        toggleCampaign: (state, action: PayloadAction<CheckedCAMPAIGN[]>) => {
            state.CheckedCampaign = action.payload;
        },
        toggleImportedCampaign: (state, action: PayloadAction<ImportedCAMPAIGN[]>) => {
            state.ImportedCampaign = action.payload;
            state.CheckedCampaign = [];
        },
        toggleRecommended: (state, action: PayloadAction<CheckedRECOMMENDED[]>) => {
            state.CheckedRecommended = action.payload;
        },
        toggleImportedRecommended: (state, action: PayloadAction<ImportedRECOMMENDED[]>) => {
            state.ImportedRecommended = action.payload;
            state.CheckedRecommended = [];
        },
        importData: (state, action: PayloadAction<ConnectedVehicleRec>) => {
            state.ConnectedVehicleRec.importError = action.payload.importError;
        },
        invokeConnectedVehicle: (state, action: PayloadAction<ConnectedVehicleRec>) => {
            state.ConnectedVehicleRec.invokeError = action.payload.invokeError;
            state.ConnectedVehicleRec.newTlmId = action.payload.newTlmId;
        },
        displayMfgInquiry: (state, action: PayloadAction<ConnectedVehicleRec>) => {
            state.ConnectedVehicleRec.printError = action.payload.printError;
        },
    },
});

export const {
    receiveConnectedVehicle,
    clearConnectedVehicle,
    printConnectedVehicle,
    invokeConnectedVehicle,
    toggleDtc,
    toggleImportedDtc,
    toggleCampaign,
    toggleImportedCampaign,
    toggleRecommended,
    toggleImportedRecommended,
    importData,
    displayMfgInquiry,
} = ConnectedVehicleSlice.actions;

export default ConnectedVehicleSlice.reducer;

export function GetConnectedVehicle() {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().Framework.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const reqData = {
            store: store,
            branch: branch,
            tlmId: tlmId,
        };
        const response =
            await acBase.eraWebServiceCall<ConnectedVehicleRec | AxiosError>
            ('CVController', 'ReadCV', reqData, store, branch);
        dispatch(receiveConnectedVehicle(response));
    };
}

export function ReloadConnectedVehicle() {
    return async (dispatch, getState: () => IStoreState) => {
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.newTlmId;
        const reqData = {
            store: store,
            branch: branch,
            tlmId: tlmId,
        };
        const response =
            await acBase.eraWebServiceCall<ConnectedVehicleRec | AxiosError>
            ('CVController', 'ReadCV', reqData, store, branch);
        dispatch(receiveConnectedVehicle(response));
    };
}

export function ClearConnectedVehicle() {
    return (dispatch) => {
        dispatch(clearConnectedVehicle());
    };
}

export function PrintConnectedVehicle(filter) {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            filter: filter,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>
            ('CVController', 'PrintCV', reqData, store, branch);
        dispatch(printConnectedVehicle(response));
    };
}

export function DisplayMfgInquiry() {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>
            ('CVController', 'DisplayInquiry', reqData, store, branch);
        dispatch(displayMfgInquiry(response));
    };
}

export function InvokeConnectedVehicle(tlmId) {
    return async (dispatch, getState: () => IStoreState) => {
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>
            ('CVController', 'InvokeCV', reqData, store, branch);
        dispatch(invokeConnectedVehicle(response));
    };
}

export function ToggleAllDtc() {
    return (dispatch, getState: () => IStoreState) => {
        const dtc = [...getState().ConnectedVehicle.ConnectedVehicleRec.dtc];
        const importedDtc = [...getState().ConnectedVehicle.ImportedDTC];
        const checkedDtc = [...getState().ConnectedVehicle.CheckedDTC];
        dtc.forEach((value) => {
            const checked = checkedDtc.findIndex((result => result.code === value.code));
            const imported = importedDtc.findIndex(result => result.code === value.code);
            if (checked === -1 && imported === -1) {
                checkedDtc.push({ code: value.code});
            }
        });
        dispatch(toggleDtc(checkedDtc));
    };
}

export function ToggleDtc(code) {
    return (dispatch, getState: () => IStoreState) => {
        let checkedDtc = [...getState().ConnectedVehicle.CheckedDTC];
        const alreadyChecked = checkedDtc.findIndex(result => result.code === code);
        if (alreadyChecked === -1) {
            checkedDtc.push({ code: code });
        } else {
            checkedDtc = checkedDtc.filter(result => result.code !== code);
        }
        dispatch(toggleDtc(checkedDtc));
    };
}

export function ToggleAllCampaign() {
    return (dispatch, getState: () => IStoreState) => {
        const campaign = [...getState().ConnectedVehicle.ConnectedVehicleRec.campaign];
        const importedCampaign = [...getState().ConnectedVehicle.ImportedCampaign];
        const checkedCampaign = [...getState().ConnectedVehicle.CheckedCampaign];
        const make = getState().ConnectedVehicle.ConnectedVehicleRec.parentMake;
        campaign.forEach((value) => {
            const checked = checkedCampaign.findIndex((result => result.code === value.code));
            const imported = importedCampaign.findIndex(result => result.code === value.code);
            const enabled = (((make === 'TY') || (make === 'LX')) && value.remedyAvailable !== 'Y') ? false : true;
            if (checked === -1 && imported === -1 && enabled === true) {
                checkedCampaign.push({ code: value.code});
            }
        });
        dispatch(toggleCampaign(checkedCampaign));
    };
}

export function ToggleCampaign(code) {
    return (dispatch, getState: () => IStoreState) => {
        let checkedCampaign = [...getState().ConnectedVehicle.CheckedCampaign];
        const alreadyChecked = checkedCampaign.findIndex(result => result.code === code);
        if (alreadyChecked === -1) {
            checkedCampaign.push({ code: code });
        } else {
            checkedCampaign = checkedCampaign.filter(result => result.code !== code);
        }
        dispatch(toggleCampaign(checkedCampaign));
    };
}

export function ToggleAllRecommended() {
    return (dispatch, getState: () => IStoreState) => {
        const recommended = [...getState().ConnectedVehicle.ConnectedVehicleRec.recommended];
        const importedRecommended = [...getState().ConnectedVehicle.ImportedRecommended];
        const checkedRecommended = [...getState().ConnectedVehicle.CheckedRecommended];
        recommended.forEach((value) => {
            const checked = checkedRecommended.findIndex((result => result.id === value.id));
            const imported = importedRecommended.findIndex(result => result.id === value.id);
            if (checked === -1 && imported === -1) {
                checkedRecommended.push({ id: value.id});
            }
        });
        dispatch(toggleRecommended(checkedRecommended));
    };
}

export function ToggleRecommended(id) {
    return (dispatch, getState: () => IStoreState) => {
        let CheckedRecommended = [...getState().ConnectedVehicle.CheckedRecommended];
        const alreadyChecked = CheckedRecommended.findIndex(result => result.id === id);
        if (alreadyChecked === -1) {
            CheckedRecommended.push({ id: id });
        } else {
            CheckedRecommended = CheckedRecommended.filter(result => result.id !== id);
        }
        dispatch(toggleRecommended(CheckedRecommended));
    };
}

export function ImportDtc() {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        const checkedDtc = [...getState().ConnectedVehicle.CheckedDTC];
        // Build a string of the checked dtc codes to pass to ERA
        const dtc: string[] = [];
        checkedDtc.forEach((value) => {
            dtc.push(value.code);
        });
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            dtc: dtc,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>('CVController', 'ImportDtc', reqData, store, branch);
        dispatch(importData(response));
        const importedDtc = [...getState().ConnectedVehicle.ImportedDTC];
        checkedDtc.forEach((value) => {
            importedDtc.push(
                { code: value.code },
            );
        });
        dispatch(toggleImportedDtc(importedDtc));
    };
}

export function ImportRecommended() {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        const checkedRecommended = getState().ConnectedVehicle.CheckedRecommended;
        // Build a string of the checked dtc codes to pass to ERA
        const recom: string[] = [];
        checkedRecommended.forEach((value) => {
            recom.push(value.id);
        });
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            recom: recom,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>('CVController', 'ImportRecommended', reqData, store, branch);
        dispatch(importData(response));
        const importedRecommended = [...getState().ConnectedVehicle.ImportedRecommended];
        checkedRecommended.forEach((value) => {
            importedRecommended.push(
                { id: value.id },
            );
        });
        dispatch(toggleImportedRecommended(importedRecommended));
    };
}

export function ImportCampaign() {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        const checkedCampaign = getState().ConnectedVehicle.CheckedCampaign;
        // Build a string of the checked dtc codes to pass to ERA
        const campaign: string[] = [];
        checkedCampaign.forEach((value) => {
            campaign.push(value.code);
        });
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            campaign: campaign,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>('CVController', 'ImportCampaign', reqData, store, branch);
        dispatch(importData(response));
        const importedCampaign = [...getState().ConnectedVehicle.ImportedCampaign];
        checkedCampaign.forEach((value) => {
            importedCampaign.push(
                { code: value.code },
            );
        });
        dispatch(toggleImportedCampaign(importedCampaign));
    };
}

export function ImportTirePressure(lf, rf, lr, rr, sp, oil) {
    return async (dispatch, getState: () => IStoreState) => {
        const tlmId = getState().ConnectedVehicle.ConnectedVehicleRec.tlmId;
        const store = getState().Framework.store;
        const branch = getState().Framework.branch;
        const stationNum = getState().Framework.stationNum;
        const taskId = getState().Framework.taskId;
        let leftFront = '';
        let rightFront = '';
        let leftRear = '';
        let rightRear = '';
        let spare = '';
        let oilLife = '';
        if (lf) {
            leftFront = 'Y';
        }
        if (rf) {
            rightFront = 'Y';
        }
        if (lr) {
            leftRear = 'Y';
        }
        if (rr) {
            rightRear = 'Y';
        }
        if (sp) {
            spare = 'Y';
        }
        if (oil) {
            oilLife = 'Y';
        }
        const reqData = {
            tlmId: tlmId,
            store: store,
            branch: branch,
            leftFront: leftFront,
            rightFront: rightFront,
            leftRear: leftRear,
            rightRear: rightRear,
            spare: spare,
            oilLife: oilLife,
            stationNum: stationNum,
            taskId: taskId,
        };
        const response =
            await acBase.eraWebServiceCall<AxiosError>('CVController', 'ImportTirePressure', reqData, store, branch);
        dispatch(importData(response));
    };
}